import script from "./DecisionComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DecisionComponent.vue?vue&type=script&lang=ts&setup=true"

import "./DecisionComponent.vue?vue&type=style&index=0&id=47e16386&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e16386"]])

export default __exports__